export default __webpack_public_path__ + "static/media/2026_Values_and_Competencies.f3997f8f.pdf";